module.exports = __webpack_public_path__ + "img/video-a2.249a4329.jpg";